import React from 'react';
import { MapPin } from 'lucide-react';
import FormLabel from './FormLabel';

interface AddressTabProps {
  formData: any;
  handleChange: (field: string, value: any) => void;
  errors?: Record<string, string>;
}

export default function AddressTab({ formData, handleChange, errors = {} }: AddressTabProps) {
  return (
    <div className="space-y-6">
      {/* Card 1: Data Alamat */}
      <div className="border rounded-lg">
        <div className="p-4 border-b">
          <h3 className="text-lg font-semibold">Data Alamat</h3>
          <p className="text-gray-500 text-sm">Alamat lengkap debitur</p>
        </div>
        <div className="p-4 space-y-4">
          <div>
            <FormLabel>Alamat Lengkap</FormLabel>
            <textarea
              value={formData.address}
              onChange={e => handleChange('address', e.target.value)}
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
              placeholder="Alamat lengkap sesuai identitas"
            />
          </div>

          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <FormLabel>Kota/Kabupaten</FormLabel>
              <input
                type="text"
                value={formData.city}
                onChange={e => handleChange('city', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                placeholder="Nama kota"
              />
            </div>

            <div>
              <FormLabel>Provinsi</FormLabel>
              <input
                type="text"
                value={formData.province}
                onChange={e => handleChange('province', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                placeholder="Nama provinsi"
              />
            </div>

            <div>
              <FormLabel>Kode Pos</FormLabel>
              <input
                type="text"
                value={formData.postal_code}
                onChange={e => handleChange('postal_code', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                placeholder="Kode pos"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Card 2: Lokasi pada Peta */}
      <div className="border rounded-lg">
        <div className="p-4 border-b">
          <h3 className="text-lg font-semibold flex items-center gap-2">
            <MapPin className="w-5 h-5 text-amber-600" />
            Lokasi pada Peta
          </h3>
          <p className="text-gray-500 text-sm">Masukkan koordinat lokasi alamat debitur</p>
        </div>
        <div className="p-4">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <FormLabel>Latitude</FormLabel>
              <input
                type="number"
                step="any"
                value={formData.latitude || ''}
                onChange={e =>
                  handleChange('latitude', e.target.value ? parseFloat(e.target.value) : null)
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                placeholder="-6.2088"
              />
            </div>

            <div>
              <FormLabel>Longitude</FormLabel>
              <input
                type="number"
                step="any"
                value={formData.longitude || ''}
                onChange={e =>
                  handleChange('longitude', e.target.value ? parseFloat(e.target.value) : null)
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                placeholder="106.8456"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
